import { NgModule, ModuleWithProviders } from '@angular/core';
import * as Ng from '@angular/router';

@NgModule({
    imports: [
        Ng.RouterModule,
    ],
    exports: [
        Ng.RouterModule,
    ],
})
export class RouterModule { }
